define('Components/ProductListWidget/js/models/CheckoutCTAWidgetInstanceModel',['jquery','Components/ProductListWidget/js/models/MediaProductListWidgetInstanceModel','app'],function($,MediaProductListWidgetInstanceModel,app){
    return MediaProductListWidgetInstanceModel.extend({
        getProduct:function(){
            var products = this.getProducts(),
            bannerProduct = products.findWhere(function(p){
                return p.isVisibleInContext();
            });
            return bannerProduct;
        }
    })
});
